import React, { useEffect } from "react"
import MapMarkerParking from "./mapMarkerParking"
import MapOverview from "./mapOverview"
import config from "react-global-configuration"
import { parkingState } from "../../zustand/parkingState"
import usePanningMap from "../../../hooks/usePanningMap"
import MapMarkerEpi from "./mapMarkerEpi"
import MapOverviewEpi from "./mapOverviewEpi"
import ParkingProductBookingStarterComponent from "../../ParkingProductBookingStarter/ParkingProductBookingStarterComponent"

const Map = (props) => {
  const {
    // props from bookingflow
    disableReservation,
    isInModal,
    history,
    allProducts,

    // props from panning map block
    headline,
    language,
    campaignExists,
    textKeys,
    markers = [],
    legends = [],
  } = props

  const texts = textKeys || config.get("textKeys.parkingList.mapModal") || {}

  const {
    parkingLotPickerContainerRef,
    panningMapContainerRef,
    panningMapInnerRef,
    panningMapDraggableRef,
    panningMapInteractiveRef,
    mobileOverlayRef,
    mobileDeactivateRef,
    mobileActivateClickHandler,
    mobileDeactivateClickHandler,
    adjustInteractives,
    constrain,
    bookingStarterData,
    setBookingStarterData,
  } = usePanningMap()

  useEffect(() => {
    adjustInteractives()
    constrain()
  }, [allProducts, markers, adjustInteractives, constrain])

  const getClass = (type) => {
    if (type.startsWith("We Park You Fly")) return "weparkyoufly"
    switch (type) {
      case "Budget":
        return "budget"
      case "Direct":
        return "direct"
      case "Standard":
        return "standard"
      case "Standard+":
        return "standard-plus"
      default:
        return false
    }
  }

  const getUniqueProducts = (all) => {
    const allSoldOut = all.filter((item) => item.product.isSoldOut)
    const uniquesProducts = all.filter(
      (item, index) =>
        all.indexOf(
          all.find((i) => i.carPark.name === item.carPark.name && i.product.categoryName === item.product.categoryName && !i.product.isSoldOut),
        ) === index,
    )
    let products = [...uniquesProducts]
    allSoldOut.forEach((item) => {
      if (!products.find((i) => item.carPark.name === i.carPark.name && i.product.categoryName === item.product.categoryName)) {
        products.push(item)
      }
    })
    return products
  }

  const renderProductMarkers = (allProducts) => {
    // renders markers for map in bookingflow
    const uniquesAllProducts = getUniqueProducts(allProducts)

    // Default center is P10, else pick a middle carpark
    let centerCarparkName = "P10"
    if (!uniquesAllProducts.find((i) => i.carPark && i.carPark.name === centerCarparkName)) {
      const index = Math.floor(uniquesAllProducts.length / 2)
      centerCarparkName = uniquesAllProducts[index]?.carPark?.name || centerCarparkName
    }

    return uniquesAllProducts.map((item) => (
      <MapMarkerParking
        key={item.product.id}
        item={item}
        getClass={getClass}
        isSingle={allProducts.length === 1}
        isCenter={item.carPark.name === centerCarparkName}
        isInModal={isInModal}
        disableReservation={disableReservation}
        history={history}
      />
    ))
  }

  return (
    <>
      {headline && ( // only for panning map block
        <section className="deck deck--white deck--padding-bottom deck--static">
          <div className="w--wider">
            <div className="action-buttons action-buttons--full action-buttons--color-brand">
              <h3 className="headline-sm">{headline}</h3>
            </div>
          </div>
        </section>
      )}
      <section className={`deck deck--white deck--padding-bottom deck--static ${parkingState.getState().isReceipt ? "no-print" : ""}`}>
        <div ref={parkingLotPickerContainerRef} className="parking-lot-picker__map js--parking-lot-picker is-active">
          {/* MAP SECTION */}
          <div className="js--parking-lot-map is-active">
            <div className={markers && markers.length > 0 ? "w--wider" : ""}>
              <div ref={panningMapContainerRef} className="panning-map js--panning-map">
                <div
                  ref={panningMapInnerRef}
                  className="panning-map__inner js--panning-map-inner"
                  style={{
                    touchAction: "none",
                    userSelect: "none",
                    WebkitUserDrag: "none",
                    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                  }}
                >
                  <div
                    ref={panningMapDraggableRef}
                    className="panning-map__draggable js--panning-map-draggable"
                    style={{
                      transform: "translate3d(0,0,0) scale3d(1,1,1)",
                      transformOrigin: "0px 0px",
                    }}
                  >
                    <div ref={panningMapInteractiveRef} className="interactive js--panning-map-interactive">
                      {allProducts && allProducts.length > 0
                        ? renderProductMarkers(allProducts)
                        : markers && markers.length > 0
                          ? markers.map((marker, index) => (
                              <MapMarkerEpi
                                key={marker.carParkName}
                                {...marker}
                                language={language}
                                textKeys={texts}
                                setBookingStarterData={() => setBookingStarterData(marker.modalText)}
                              />
                            ))
                          : null}
                      <div
                        className="map-label"
                        data-positionstyle="left:20%;top:52%;"
                        style={{
                          transform: "scale3d(1,1,1)",
                          left: "20%",
                          top: "52%",
                        }}
                      >
                        <span className="text">{texts.terminal2 || "Terminal 2"}</span>
                      </div>
                      <div
                        className="map-label"
                        data-positionstyle="left:30%;top:64%;"
                        style={{
                          transform: "scale3d(1,1,1)",
                          left: "30%",
                          top: "64%",
                        }}
                      >
                        <span className="text">{texts.terminal3 || "Terminal 3"}</span>
                      </div>
                    </div>

                    <div className="image js--panning-map-image" style={{ backgroundImage: 'url("/static/photos/parkeringskort5.jpg")' }}>
                      <img src="/static/photos/parkeringskort5.jpg" alt="map" />
                    </div>
                  </div>
                </div>

                <div ref={mobileOverlayRef} className="panning-map__overlay is-active js--mobile-overlay">
                  <button className="button button--small button--general-inverted js--mobile-activate" onClick={mobileActivateClickHandler}>
                    <span className="text">{texts.activateMap || "Aktivér Kortet"}</span>
                  </button>
                </div>

                <button ref={mobileDeactivateRef} className="button button--icon js--mobile-deactivate" onClick={mobileDeactivateClickHandler}>
                  <span className="icon">
                    <svg className="svg-icon svg-icon--close-new">
                      <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-close-new">
                        &nbsp;
                      </use>
                    </svg>
                  </span>
                </button>
              </div>

              {allProducts && allProducts.length > 1 ? (
                <MapOverview getClass={getClass} />
              ) : legends && legends.length > 0 ? (
                <MapOverviewEpi legends={legends} campaignExists={campaignExists} textKeys={texts} />
              ) : null}
            </div>
          </div>
        </div>
      </section>
      {markers && markers.length > 0 && bookingStarterData ? (
        <ParkingProductBookingStarterComponent productData={bookingStarterData} modalCloseCallBack={() => setBookingStarterData(null)} />
      ) : (
        ""
      )}
    </>
  )
}

export default Map
